const popupBodyBoxStyle = { margin: '20px 0px' };

export { popupBodyBoxStyle };